import { ref, computed } from 'vue';
import axios from 'axios';
import { sanitizeHtml } from '../utils/sanitize';

export function useFaq() {
  const faqs = ref([]);
  const isLoading = ref(false);
  const activeFaq = ref(null);
  const error = ref(null);

  const fetchFaqs = async () => {
    isLoading.value = true;
    error.value = null;
    try {
      const response = await axios.get('/frontend/faqs');
      faqs.value = response.data.map((faq) => ({
        ...faq,
        answer: sanitizeHtml(faq.answer),
      }));
    } catch (err) {
      error.value = err;
    } finally {
      isLoading.value = false;
    }
  };

  const toggleFaq = (index) => {
    activeFaq.value = activeFaq.value === index ? null : index;
  };

  const allTags = computed(() => {
    const tags = new Set();
    faqs.value.forEach((faq) => {
      if (faq.tags && Array.isArray(faq.tags)) {
        faq.tags.forEach((tag) => tags.add(tag));
      }
    });
    return Array.from(tags).sort();
  });

  return {
    faqs,
    isLoading,
    activeFaq,
    error,
    allTags,
    fetchFaqs,
    toggleFaq,
  };
}
